import React from 'react';
import { Button } from './ui/Button';
import { TruckIcon, ShieldCheckIcon, ClockIcon } from 'lucide-react';
export function ShippingBanner() {
  const features = [{
    icon: TruckIcon,
    text: 'Envíos rápidos'
  }, {
    icon: ShieldCheckIcon,
    text: 'Seguros'
  }, {
    icon: ClockIcon,
    text: 'Garantizados'
  }];
  return <section id="envios" className="w-full bg-blue-900 text-white py-16 md:py-20" data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8" data-id="element-190">
          <div className="text-center lg:text-left flex-1" data-id="element-191">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-192">
              Envíos rápidos, seguros y garantizados
            </h2>
            <p className="text-xl text-blue-100 mb-6" data-id="element-193">
              Tu tranquilidad es nuestra prioridad. Seguimiento en tiempo real
              de todos tus envíos.
            </p>

            <div className="flex flex-wrap gap-6 justify-center lg:justify-start mb-6" data-id="element-194">
              {features.map((feature, index) => {
              const Icon = feature.icon;
              return <div key={index} className="flex items-center gap-2" data-id="element-195">
                    <Icon className="h-6 w-6 text-red-400" data-id="element-196" />
                    <span className="font-semibold" data-id="element-197">{feature.text}</span>
                  </div>;
            })}
            </div>
          </div>

          <div className="flex-shrink-0" data-id="element-198">
            <Button variant="primary" className="text-lg px-8 py-4" data-id="element-199">
              Enviar ahora
            </Button>
          </div>
        </div>
      </div>
    </section>;
}